import { memo } from "react";

function PolygonFilled({ size = 18 }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor">
      <path
        opacity=".25"
        d="M16.05,6.54H8A2.57,2.57,0,0,1,6.54,8v8.1A2.57,2.57,0,0,1,8,17.46h8.1a2.72,2.72,0,0,1,.33-.57L15,14.53a2.57,2.57,0,1,1,0-5.06l1.41-2.36A2.72,2.72,0,0,1,16.05,6.54Z"
      />
      <path d="M18.43,8.14a2.57,2.57,0,1,0-2.38-3.53H8A2.57,2.57,0,1,0,4.61,8v8.1A2.57,2.57,0,1,0,8,19.39h8.1a2.61,2.61,0,1,0,2-3.49l-1.41-2.36a2.54,2.54,0,0,0,0-3.08L18,8.1A2.58,2.58,0,0,0,18.43,8.14Zm0,9.65a.64.64,0,0,1,.64.64.64.64,0,0,1-.64.64.64.64,0,0,1,0-1.28ZM5.57,19.07a.64.64,0,0,1-.64-.64.64.64,0,1,1,.64.64Zm0-12.86a.64.64,0,0,1-.64-.64.64.64,0,0,1,.64-.64.64.64,0,1,1,0,1.28ZM15,9.47a2.57,2.57,0,1,0,0,5.06l1.41,2.36a2.72,2.72,0,0,0-.33.57H8a2.57,2.57,0,0,0-1.41-1.41V8A2.57,2.57,0,0,0,8,6.54h8.1a2.72,2.72,0,0,0,.33.57ZM15.21,12a.64.64,0,0,1-.64.64.64.64,0,0,1,0-1.28A.64.64,0,0,1,15.21,12Zm2.58-6.43a.64.64,0,0,1,.64-.64.64.64,0,0,1,.64.64.64.64,0,1,1-1.28,0Z" />
    </svg>
  );
}
export default memo(PolygonFilled);
